import { useState, useCallback, useEffect } from 'react';

/**
 * Hook to trigger a shake animation.
 * Returns:
 * - isShaking: boolean indicating if animation is active
 * - triggerShake: function to start the shake
 * - shakeClassName: string to apply to the element (e.g. 'animate-shake')
 */
export function useShake(duration = 400) {
    const [isShaking, setIsShaking] = useState(false);

    useEffect(() => {
        if (isShaking) {
            const timer = setTimeout(() => setIsShaking(false), duration);
            return () => clearTimeout(timer);
        }
    }, [isShaking, duration]);

    const triggerShake = useCallback(() => {
        setIsShaking(true);
    }, []);

    return {
        isShaking,
        triggerShake,
        shakeClassName: isShaking ? 'animate-shake' : '',
    };
}
